var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { ref: "joystickWrapper", staticClass: "joystick-wrapper" },
    [
      _c(
        "div",
        {
          ref: "joystick",
          staticClass: "joystick",
          class: {
            "joystick--scaling": _vm.isScaling,
            "joystick--moving": _vm.isMoving,
          },
          style: _vm.cssVars,
          attrs: { draggable: "false" },
        },
        [
          _vm.isRotation
            ? _c("JoystickRotationBackgroundSVG", {
                staticClass: "joystick__background",
              })
            : _vm.isScaling
            ? _c("JoystickScalingBackgroundSVG", {
                staticClass: "joystick__background",
              })
            : _c("JoystickPositionBackgroundSVG", {
                staticClass: "joystick__background",
              }),
          _c(
            "div",
            { ref: "handle", staticClass: "joystick__handle" },
            [
              _vm.isRotation
                ? _c("JoystickRotationHandleSVG")
                : _c("JoystickPositionHandleSVG", {
                    attrs: { isScaling: _vm.isScaling },
                  }),
            ],
            1
          ),
          _c(
            "div",
            {
              ref: "closeButton",
              staticClass: "joystick__close",
              on: { click: _vm.onClose },
            },
            [_c("CrossButton")],
            1
          ),
          _c(
            "div",
            {
              ref: "acceptButton",
              staticClass: "joystick__accept",
              on: { click: _vm.onFinish },
            },
            [_c("AcceptButton")],
            1
          ),
          _vm.isScaling
            ? _c(
                "div",
                {
                  ref: "resetButton",
                  staticClass: "joystick__reset",
                  class: {
                    "joystick__reset--disabled":
                      _vm.scale === _vm.DEFAULT_SCALE,
                  },
                  on: { click: _vm.onReset },
                },
                [_c("ResetButton")],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }